<!-- Global components (always rendered) -->
<ui-toast aria-live="polite" aria-atomic="true"></ui-toast>
<app-size-detector></app-size-detector>
@if (user && !isAdminRoute && !isShadcnRoute) {
  <app-dialog-launcher></app-dialog-launcher>
  <app-dialog-panel></app-dialog-panel>
}

@if (isAdminRoute || isShadcnRoute) {
  <!-- Admin area / shadcn spike: each provides its own full-page shell & nav -->
  <router-outlet></router-outlet>
} @else {
  <!-- User app: wrapped in the standard DaisyUI drawer navigation -->
  <app-shell [user]="user" [onLogout]="logout.bind(this)">
    <div class="w-full px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-8">
      <router-outlet></router-outlet>
    </div>
  </app-shell>
}
